<!-- APP--APP管理--二维码 -->
<template>
  <div class="md-layout">
    <!-- 表单-配置下载地址 -->
    <div class="md-layout-item md-size-60 md-xsmall-size-100">
      <md-card >
        <!-- 卡片-头部 -->
        <md-card-header class=" md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>link</md-icon>
          </div>
          <!-- 按钮-添加新的详情 -->
          <h4 class="title" :style="{'text-align':'left'}">
            {{$I18n("set_app_download")}} 
            <md-button @click="url_form.details.push({zone:'ALL',lang_inp:'',url:''})" :style="{'float':'right'}" class="md-just-icon md-round md-primary md-info">
              <md-icon>add</md-icon>
            </md-button>
          </h4>
          <!-- 卡片-小标题 -->
          <div class="md-subhead">{{$I18n("qrcode_info")}}</div>
        </md-card-header>
        <!-- 卡片-主体-表单内容 -->
        <md-card-content>
          <div class="md-layout">
            <!-- 表单-单选按钮-状态 -->
            <div class="md-layout md-layout-item md-size-75">
              <label class=" md-size-20 md-form-label md-form-label-out">
                {{$I18n("state")}}:
              </label>
              <div class="md-layout-item md-size-80 md-form-item" :style="{'padding-top': '5px'}">
                <md-radio v-model="url_form.state" :value="1">{{$I18n("open")}}</md-radio>
                <md-radio v-model="url_form.state" :value="2">{{$I18n("close")}}</md-radio>
              </div>
            </div>
            <!-- 表单-详情表单 -->
            <div v-for="(formItem, index) in url_form.details" :key="index" class="md-layout-item mx-auto md-size-100">
              <md-card>
                <md-card-content class="md-layout">
                  <div :style="{padding:'0'}" class="md-layout-item md-layout md-size-90">
                    <!-- 表单-选择框-地区 -->
                    <div :class="{'md-size-50': !formItem.zone }" :style="{'padding-right': !!formItem.zone ?'15px' :'0'}" class="md-layout-item md-layout">
                      <label :class="{'md-size-30': !formItem.zone, 'md-size-15': !!formItem.zone}" class="md-layout-item md-form-label">
                        {{$I18n("oat_zone")}}:
                      </label>
                      <div :class="{'md-size-70': !formItem.zone, 'md-size-85': !!formItem.zone}" class="md-layout-item">
                        <md-field>
                          <md-select v-model="formItem.zone">
                            <md-option value="">{{$I18n("other_zone")}}</md-option>
                            <md-option value="ALL">{{$I18n("all")}}</md-option>
                            <md-option value="CN">{{$I18n("China")}}</md-option>
                          </md-select>
                        </md-field>
                      </div>
                    </div>
                    <!-- 表单-输入栏-地区 {只有选择'其他地区'以后才会显示} -->
                    <div v-show="!formItem.zone" class="md-layout-item md-layout md-size-50">
                      <label class="md-layout-item md-size-30 md-form-label">
                        {{$I18n("oat_zone")}}:
                      </label>
                      <div class="md-layout-item md-size-70">
                        <md-field>
                          <md-input v-model="formItem.inp_lang"/>
                        </md-field>
                      </div>
                    </div>
                  </div>
                  <!-- 表单-按钮-删除该详情 -->
                  <div class="md-layout-item md-size-10">
                    <md-button @click="url_form.details.splice(index,1)" :style="{'float':'right'}" class="md-primary md-sm md-info right-button md-just-icon md-round">
                      <md-icon>close</md-icon>
                    </md-button>
                  </div>
                  <!-- 表单-输入栏-URL -->
                  <div class="md-layout-item md-layout md-size-90">
                    <label class="md-layout-item md-size-15 md-form-label"> {{$I18n("oat_url")}}: </label>
                    <div class="md-layout-item md-size-85 ">
                      <md-field>
                        <md-input v-model="formItem.url"></md-input>
                      </md-field>
                    </div>
                  </div>
                </md-card-content>
              </md-card>
            </div>
            <!-- 表单-按钮-提交表单数据 -->
            <div class="md-layout-item mx-auto md-size-100">
              <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <!-- 卡片-显示二维码以及提供下载 -->
    <div class="md-layout-item md-size-40 md-xsmall-size-100">
      <md-card >
        <!-- 卡片-头部 -->
        <md-card-header class=" md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>qr_code</md-icon>
          </div>
          <h4 class="title" :style="{'text-align':'left'}"> {{$I18n("view_qrcode")}} </h4>
        </md-card-header>
        <!-- 卡片-主体 -->
        <md-card-content>
          <div>{{$I18n("real_qrcode_url")}} :</div>
          <!-- 二维码对应的URL -->
          <div>http://ota.umeye.com/ota/appurl.html?appid={{app_id}}</div>
          <!-- 二维码 -->
          <div :style="{ 'width':'200px','height':'200px' }" class="mx-auto">
            <vue-qr :text="'http://ota.umeye.com/ota/appurl.html?appid=' + app_id" ref="qr" />
          </div>
          <!-- 按钮-点击下载二维码 -->
          <div class="md-layout" :style="{'text-align': 'center'}">
            <div class="md-layout-item mx-auto">
              <md-button @click="downloadQrcode" class="md-primary md-info">
                <md-icon>download</md-icon>
                {{$I18n("image_download")}}
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <modal key="main" v-show="modal" @close="modal_closeModal" class="lg-modal">
      <!-- 弹窗-头部 -->
      <template slot="header">
        <h4 class="modal-title">{{modalTitle}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_closeModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <!-- 弹窗-主体 -->
      <template slot="body">
        <div>{{$I18n("is_sure_edit")}}</div>
      </template>
      <!-- 弹窗-底部按钮 -->
      <template slot="footer">
        <md-button @click="modal_submit" class="left-icon md-info">{{$I18n("sure")}}</md-button>
        <md-button @click="modal_closeModal" class="">{{$I18n("cancel")}}</md-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Modal } from '@/components';
import vueQr from 'vue-qr'

export default {
  components: {
    Modal,
    vueQr,
  },
  props: {
    app_id : {
      type: String,
      default: "",
    },
 },
  data(){
    return {
      url_form  : {                   // 左侧表格数据
        app_id : "",
        state  : 2,                   // 是否开启
        details: [],
      }, 
      modal     : false,              // 是否打开弹窗
      modalTitle: this.$I18n("tips"), // 弹窗标题
      modalType : "",                 // 弹窗类型
    }
  },
  methods: {
    downloadQrcode(){ // 下载二维码
      var a= document.createElement('a');
      document.body.appendChild(a);
      a.href= this.$refs.qr.$el.src;
      a.download= this.$I18n("qrcode");
      a.click();
    },
    modal_openModal (){ // 弹窗-打开弹窗
      this.modal = true;
    },
    modal_closeModal(){ // 弹窗-关闭弹窗
      this.modal = false;
    },
    modal_submit(){ // 弹窗-提交弹窗表单的内容
      let sendData =  {
        ...this.url_form,
        details: this.url_form.details.map(item => {
          return {
            ...item,
            zone : item.zone !== '' ?item.zone :item.inp_lang,
          }
        }),
      }
      if(this.url_form.id) { // 修改URL
        this.$api.editAppUrl(sendData)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("add_success"));
            this.modal_closeModal();
            this.api_getUrl();
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      } else { // 添加URL
        this.$api.addAppUrl(sendData)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("edit_success"));
            this.modal_closeModal();
            this.api_getUrl();
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      }
    },
    api_getUrl (){ // API-获取URL
      this.url_form = {
        app_id : this.app_id,
        state  : 2,
        details: [],
      }
      this.$api.appUrlQuery({ // api: /ota/app/url/query
        app_id : this.app_id,
      })
        .then(this.$Then(res => {
          if(res.data.length > 0){
            this.url_form = {
              ...res.data[0],
              details: res.data[0].details
                ? [...res.data[0].details] .map(item => {
                  let inp_lang = ""
                  if(item.zone !== "ALL" && item.zone !== "CN"){
                    inp_lang = item.zone;
                  }
                  return {
                    ...item,
                    zone: inp_lang ?"" :item.zone, 
                    inp_lang,
                  }
                })
                : [],
            };
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
  },
  created(){
    this.api_getUrl();
  },
}
</script>
<style lang="scss" scoped>
  .md-subhead {
    text-align:left;
    margin-left: 80px;
  }
  .md-form-label-out{
    padding-left:  15px !important;
    padding-rigth: 15px !important;
  }
</style>